import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <div className='footer'>
            <Container>
                <Row>
                    <Col>
                        <p className='footer-top'>
                            <Link to="/termsconditions">Terms & Conditions</Link> ||
                            <Link to="/privacypolicy">Privacy Policy</Link>
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col><p className='footer-bottom'>© {currentYear} Atum Charge. All Rights Reserved. </p></Col>
                </Row>
            </Container>
        </div>
    )
}

export default Footer